import Amplify from 'aws-amplify';
import React from 'react';
import { Provider } from 'react-redux';
import './App.scss';
import CustomAuthenticator from './auth/components/CustomAuthenticator';
import aws_exports from './aws-exports';
import store from './redux/store';
import Routes from './Routes';
import { getMicroservicesDomain } from './utils';
import { ThemeProvider } from './theme';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateUtils from '@date-io/date-fns';
import {getDefaultHeaders} from "./utils/http";

let domainExports = [];
let domain = getMicroservicesDomain();

domainExports.push({
    name: 'admin',
    endpoint: 'admin',
    region: 'eu-west-1',
});

domainExports.push({
    name: 'order',
    endpoint: 'orders',
    region: 'eu-west-1',
});

domainExports.push({
    name: 'product',
    endpoint: 'products',
    region: 'eu-west-1',
});

domainExports.push({
    name: 'delivery',
    endpoint: 'delivery',
    region: 'eu-west-1',
});

for (const { name, endpoint, region } of domainExports) {
    const url = endpoint.match(/https:\/\//g) ? endpoint : `${domain}/${endpoint}`;
    aws_exports.aws_cloud_logic_custom.push({
        endpoint: url,
        region,
        name,
        custom_header: async () => ({ ...await getDefaultHeaders() })
    });
}

Amplify.configure(aws_exports);

const App = () => {
    return (
        <ThemeProvider>
            <MuiPickersUtilsProvider utils={DateUtils}>
                <main className="full-height">
                    <Provider store={store}>
                        <CustomAuthenticator>
                            <Routes store={store} />
                        </CustomAuthenticator>
                    </Provider>
                </main>
            </MuiPickersUtilsProvider>
        </ThemeProvider>
    );
};

export default App;
